import React, { forwardRef } from 'react';
import DatePicker from 'react-datepicker';
import { Box, Input } from '@chakra-ui/react';

import 'react-datepicker/dist/react-datepicker.css';

const DateRangeSelect: React.FC<{
  dateRange: (Date | null)[];
  // eslint-disable-next-line no-unused-vars
  setDateRange: (data: (Date | null)[]) => void;
}> = ({ dateRange, setDateRange }) => {
  const [startDate, endDate] = dateRange;

  // eslint-disable-next-line react/display-name
  const ExampleCustomInput: any = forwardRef(
    ({ value, onClick }: any, ref: any) => (
      <Input
        readOnly
        onClick={onClick}
        ref={ref}
        value={value}
        placeholder="Select date range"
        bg="dark"
        color="body"
        borderWidth="1px"
        borderColor="body2"
        borderRadius="lg"
        fontSize="sm"
        h="40px"
        minW={{ base: '100%', sm: '14rem' }}
        w={{ base: '100%', sm: '14rem' }}
        px={3}
        cursor="pointer"
        _placeholder={{ color: 'body2' }}
        _hover={{ bg: 'rgba(255, 255, 255, 0.04)' }}
        _focus={{ borderColor: 'primary', boxShadow: 'none' }}
      />
    )
  );

  return (
    <Box>
      <DatePicker
        startDate={startDate}
        endDate={endDate}
        onChange={(update) => {
          setDateRange(update);
        }}
        onCalendarClose={() => {
          return dateRange.includes(null) ? setDateRange([null, null]) : true;
        }}
        customInput={<ExampleCustomInput />}
        isClearable
        selectsRange
      />
    </Box>
  );
};

export default DateRangeSelect;
